import React from 'react';
import { Box, Button, TableCell, TableRow } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PropTypes from 'prop-types';
import { formatFileSize } from '../../util/fileUtils';

const FileRow = ({ file, onDelete, style, classes }) => {
  const handleDelete = () => {
    onDelete(file.id, file.name);
  };

  return (
    <TableRow className={style} hover>
      <TableCell className={classes.tableCell}>{file.name}</TableCell>
      <TableCell className={classes.tableCell}>{file.uploadedBy}</TableCell>
      <TableCell className={classes.tableCell}>{file.uploadedAt}</TableCell>
      <TableCell className={classes.tableCell}>{formatFileSize(file?.size)}</TableCell>
      <TableCell className={classes.tableCell}>
        <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {file.url}
          <Button aria-label="Copy url" variant="text" color="primary"
                  onClick={() => navigator.clipboard.writeText(file.url)} startIcon={<FileCopyIcon />}>
            Copy
          </Button>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Button variant="text" color="secondary" onClick={handleDelete} aria-label={`Delete ${file.name}`}
                startIcon={<HighlightOffIcon />}>
          Delete
        </Button>
      </TableCell>
    </TableRow>
  );
};

FileRow.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    uploadedBy: PropTypes.string.isRequired,
    uploadedAt: PropTypes.string.isRequired,
    url: PropTypes.string,
    size: PropTypes.number,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  style: PropTypes.string,
  classes: PropTypes.shape({
    tableCell: PropTypes.string.isRequired,
  }).isRequired,
};

export default FileRow;
